import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../services/supabaseClient';

const DashboardAdmin = () => {
  const { userRole } = useAuth();
  // Jumlah dibaca dari registrations. Hak baca peran (RLS) sudah membatasi Admin DPW ke wilayahnya.
  const [counts, setCounts] = useState(null);

  // Antrean yang menjadi tugas peran ini
  const antreanLink = userRole === 'admin_nasional' ? '/admin/approval' : '/admin/verifikasi';

  useEffect(() => {
    let isMounted = true;

    // Admin DPP memutuskan pengajuan dari kedua tahap (tahap DPW tidak diwajibkan selama uji coba)
    const antreanStatus = userRole === 'admin_nasional'
      ? ['Menunggu verifikasi', 'Menunggu verifikasi nasional']
      : ['Menunggu verifikasi'];

    const countRows = async (status) => {
      let query = supabase.from('registrations').select('id', { count: 'exact', head: true });
      if (status) query = query.in('status', status);
      const { count, error } = await query;
      if (error) throw error;
      return count;
    };

    const fetchCounts = async () => {
      try {
        const [total, antrean, disetujui] = await Promise.all([
          countRows(null),
          countRows(antreanStatus),
          countRows(['Disetujui'])
        ]);
        if (isMounted) setCounts({ total, antrean, disetujui });
      } catch (err) {
        console.error('Error fetching ringkasan dashboard:', err);
      }
    };

    fetchCounts();
    return () => { isMounted = false; };
  }, [userRole]);

  // Stat cards data menggunakan STRICTLY warna dari tailwind.config (yang sudah di-map ke Hex)
  const stats = [
    { name: 'Total Pendaftar', value: counts ? counts.total : '-', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z', color: 'bg-emerald-50 text-emerald-600' }, // Primary Blue
    { name: userRole === 'admin_nasional' ? 'Menunggu Persetujuan DPP' : 'Menunggu Verifikasi DPW', value: counts ? counts.antrean : '-', link: antreanLink, icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z', color: 'bg-emerald-50 text-emerald-400' }, // Yellow
    { name: 'Anggota Disetujui', value: counts ? counts.disetujui : '-', icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z', color: 'bg-emerald-50 text-emerald-800' }, // Dark Green
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Dashboard</h1>
        <p className="mt-1 text-sm text-slate-500">Ringkasan aktivitas dan status keanggotaan HEBITREN saat ini.</p>
      </div>

      {/* Stat Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((item) => (
          <div key={item.name} className="bg-white overflow-hidden shadow-sm rounded-xl border border-slate-200 hover:shadow-md transition-shadow">
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className={`p-3 rounded-md ${item.color} border border-slate-100 shadow-sm`}>
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d={item.icon} />
                    </svg>
                  </div>
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-slate-500 truncate">{item.name}</dt>
                    <dd className="text-2xl font-bold text-slate-900">{item.value}</dd>
                  </dl>
                </div>
              </div>
            </div>
            {item.link && (
              <div className="bg-slate-50 px-5 py-3 border-t border-slate-100">
                <div className="text-sm">
                  <Link to={item.link} className="font-medium text-emerald-600 hover:text-emerald-800 flex items-center transition-colors">
                    Lihat detail
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                  </Link>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardAdmin;
